export const goBack = (navigate) => {
    navigate(-1)
}
